import { withPriceSeperator } from '@flight-workspace/common-client/src/util/number';
import classNames from 'classnames/bind';
import CityImage from 'common/cityImage';
import { getDurationKr } from 'common/utils';
import { MouseEventHandler } from 'react';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  cityImage: string;
  departureCityName: string;
  departureCityCode: string;
  arrivalCityName: string;
  arrivalCityCode: string;
  stops: number;
  duration: number;
  price: number;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  onOpenChart?: MouseEventHandler<HTMLButtonElement>;
}

export default function RecommendItem({
  cityImage,
  departureCityName,
  departureCityCode,
  arrivalCityName,
  arrivalCityCode,
  stops,
  duration,
  price,
  onClick,
  onOpenChart,
}: IProps) {
  return (
    <div className={cx('RecommendItem')}>
      <button
        type="button"
        className={cx('anchor')}
        data-event-nlog="click"
        data-event-area-code="rcm.listselect"
        onClick={onClick}
      >
        <figure className={cx('thumb')}>
          <CityImage
            alt={arrivalCityName}
            className={cx('img')}
            imagePath={cityImage}
            type="f70_70_fst"
          />
        </figure>
        <div className={cx('details')}>
          <>
            <strong className={cx('routes')}>
              <span className={cx('start')}>
                <i className={cx('name')}>{departureCityName}</i>
                <b className={cx('code')}>{departureCityCode}</b>
              </span>
              <span className={cx('end')}>
                <i className={cx('name')}>{arrivalCityName}</i>
                <b className={cx('code')}>{arrivalCityCode}</b>
              </span>
            </strong>
            <i className={cx('info')}>
              {stops === 0 ? '직항' : `경유 ${stops}회`},{' '}
              {getDurationKr(duration)}
            </i>
            <b className={cx('fare')}>
              <span className={cx('amount')}>{withPriceSeperator(price)}</span>
              <span className={cx('unit')}>원~</span>
            </b>
          </>
        </div>
      </button>
      <button
        type="button"
        className={cx('chart')}
        aria-label="그래프"
        data-event-nlog="click"
        data-event-area-code="rcm.listgraph"
        onClick={onOpenChart}
      />
    </div>
  );
}
